module.exports = __webpack_public_path__ + "images/services/bitbucket-mark-contained-gradient-blue.ca0b7b730f5b26d1b703.svg";